import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../../../PageBuilder/components/FormField/abstract-form-field.component';
import { FormFieldModel } from '../../../PageBuilder/models/form-field.model';
import { externalDataSeriesTypes, SeriesTypeEnum } from '../../enums/series-type.enum';

export class ExternalDataSourcePickerFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    allowedSeriesTypes: SeriesTypeEnum[];
    showColor: boolean;
    headingId?: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description?: string,
        allowedSeriesTypes: SeriesTypeEnum[] = externalDataSeriesTypes,
        showColor: boolean = true,
        headingId?: string
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.allowedSeriesTypes = allowedSeriesTypes;
        this.showColor = showColor;
        this.headingId = headingId;
    }
}
